// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"6a2038bd","1782":"a6a09b3d","8669":"8e025e71"}[chunkId] + ".chunk.css";
};